import React, { Component } from "react";
import "./Background.scss";

export default function Background() {
    return (
      <div>
        <div class="shootingStarContainer">
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
          <div class="shootingStar"></div>
        </div>
        <div class="shootingStarContainer">
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
        </div>
        <div class="shootingStarContainer">
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
            <div class="shootingStar"></div>
        </div>
        <div class="stars"></div>
        <div class="twinkleMask"></div>
        <div class="twinkleMask2"></div>
        <div class="clouds"></div>

        <div class="fogContainer">
            <div class="fog"></div>
        </div>
      </div>
  );
};
